import { Component, Inject, OnInit } from '@angular/core';
import { ExecutionQTestDataObservations } from '../../../../model/execution';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ExecutionQTestDataObservationsService } from '../../../../services/executionQTestDataObservations.service';
import { Subject, takeUntil } from 'rxjs';

export interface DialogDataObservations {
  data: ExecutionQTestDataObservations;
  idExecutionTest: number;
  position: number;
  isEdit: boolean;
  btnCancel: boolean;
}

@Component({
    selector: 'app-execution-edit-q-test-observations',
    templateUrl: './execution-edit-q-test-observations.component.html',
    styleUrl: './execution-edit-q-test-observations.component.scss',
    standalone: false,
})
export class ExecutionEditQTestObservationsComponent implements OnInit {

    private destroy$ = new Subject<void>();
    constructor(
      private translate: TranslateService,
      private dialogRef: MatDialogRef<ExecutionEditQTestObservationsComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogDataObservations,
      public snackBarService: SnackBarService,
      private executionQTestDataObservationsService: ExecutionQTestDataObservationsService,
      private spinnerService: SpinnerService) {
    }

    ngOnInit(): void {
      if (!this.data.isEdit) {
        this.data.data.position = this.data.position;
      }
    }

    onOkClick(): void {
      const errs = [];
  
      if (this.data.data.description == null) {
        errs.push(this.translate.instant('executionEdit.test.observations.description.error'));
      }
  
      this.data.data.idExecutionTest = this.data.idExecutionTest;
      if (errs.length === 0) {
        this.spinnerService.show();
        this.executionQTestDataObservationsService.save(this.data.data).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDataObservations) => {
          this.spinnerService.hide();

          this.dialogRef.close(true);
        }, error => {
          this.spinnerService.hide();
          this.snackBarService.sendError(this.translate.instant('executionEdit.test.observations.save.error'));

        });
      } else {
        const error = errs.join('\n');
        this.snackBarService.sendError(error);
      }
    }

    onNoClick() {
      this.dialogRef.close();
    }
}
